// Android only.

export function initialize() {}

export async function dismissCallNotification() {}

export async function showOngoingCallNotification(_sessionId?: string) {}
